import { createAction } from 'typesafe-actions';

export const setThemeSpotlightVisited = createAction(
  'SET_THEME_SPOTLIGHT_VISITED'
)<boolean>();

export const setThemeSpotlightExpired = createAction(
  'SET_THEME_SPOTLIGHT_EXPIRED'
)();

export const setCurrencySpotlightVisited = createAction(
  'SET_CURRENCY_SPOTLIGHT_VISITED'
)<boolean>();

export const setCurrencySpotlightExpired = createAction(
  'SET_CURRENCY_SPOTLIGHT_EXPIRED'
)();

export const setActivityExportSpotlightVisited = createAction(
  'SET_ACTIVITY_EXPORT_SPOTLIGHT_VISITED'
)<boolean>();

export const setActivityExportSpotlightExpired = createAction(
  'SET_ACTIVITY_EXPORT_SPOTLIGHT_EXPIRED'
)();

export const setCsprClickBarSpotlightVisited = createAction(
  'SET_CSPRCLICKBAR_SPOTLIGHT_VISITED'
)<boolean>();

export const setCsprClickBarSpotlightExpired = createAction(
  'SET_CSPRCLICKBAR_SPOTLIGHT_EXPIRED'
)();

export const setAssociatedKeysSpotlightVisited = createAction(
  'SET_ASSOCIATED_KEYS_SPOTLIGHT_VISITED'
)<boolean>();

export const setAssociatedKeysSpotlightExpired = createAction(
  'SET_ASSOCIATED_KEYS_SPOTLIGHT_EXPIRED'
)();

export const setAccountsPageSpotlightVisited = createAction(
  'SET_ACCOUNTS_PAGE_SPOTLIGHT_VISITED'
)<boolean>();

export const setAccountsPageSpotlightExpired = createAction(
  'SET_ACCOUNTS_PAGE_SPOTLIGHT_EXPIRED'
)();
export const setNodeLunchSpotlightVisited = createAction(
  'SET_NODE_LUNCH_SPOTLIGHT_VISITED'
)<boolean>();

export const setNodeLunchSpotlightExpired = createAction(
  'SET_NODE_LUNCH_SPOTLIGHT_EXPIRED'
)();

export const setNodeLunchSpotlightIgnored = createAction(
  'SET_NODE_LUNCH_SPOTLIGHT_IGNORED'
)<boolean>();
